import Leftlayout from "../leftlayout/Leftlayout";
import RelateTable from "../relatetable/RelateTable";

const MainRelateTable = () => {
  return (
    <div className="mainrelatetable">
      <div className="layouttable-left">
        <Leftlayout />
      </div>
      <div className="layouttable-right">
        <RelateTable />
      </div>
    </div>
  );
};

export default MainRelateTable;
